import { Link } from 'react-router-dom';

export function NotFoundContent() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-200 border border-background-300/40 mb-6">
        <i className="ri-emotion-sad-line text-3xl text-foreground-500"></i>
      </div>
      <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-100 mb-3">
        页面未找到
      </h1>
      <p className="text-foreground-500 mb-8 max-w-md">
        你寻找的页面似乎进入了暗影深处，或许它从未存在，又或许它只是暂时隐藏了踪迹。
      </p>
      <Link
        to="/"
        className="px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 font-label text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
      >
        <i className="ri-home-4-line mr-2"></i>
        返回首页
      </Link>
    </div>
  );
}

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center">
      <NotFoundContent />
    </div>
  );
}